
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 115 32"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#a)"}},[_c('path',{attrs:{"d":"M4.7 16.86h11.91v-4.09H4.71V4.3h13.42V.13H0v28.35h18.71V24.3h-14v-7.45zm95.38 0h11.9v-4.09h-11.9V4.3h13.43V.13H95.38v28.35h18.71V24.3h-14v-7.45zM76.4.14h-9.5v28.4h4.72v-8.63h4.8a9.89 9.89 0 100-19.77zm0 15.45h-4.8V4.46h4.8a5.57 5.57 0 110 11.13zm-20.8-1.11a14.52 14.52 0 10-7.35 12.58L52.52 32l3.32-2.87-4.12-4.8c2.5-2.68 3.88-6.2 3.87-9.85zM48.8 21l-3.74-4.34-3.32 2.88 3.56 4.11A10.11 10.11 0 1148.8 21z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h114.09v32H0z"}})])])])
          )
        }
      }
    